import React from 'react';

const Analytics = () => (
  <div style={{ padding:'1rem' }}>
    <h1 style={{ marginTop:0 }}>Analytics</h1>
    <p>Sales performance, conversion metrics, and trend visualizations will be added.</p>
  </div>
);

export default Analytics;
